import { React, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import logo from "../../../assets/img/logo-nanny.png";
import { useDispatch, useSelector } from "react-redux";
import { clearData, loginUser } from "../../../store/apiSlice/LoginSlice";
import { Button } from "react-bootstrap";
import { useGoogleLogin } from '@react-oauth/google';
import { GoogleLogin } from '@react-oauth/google';
import { ClipLoader } from "react-spinners";
import '@fortawesome/fontawesome-free/css/all.min.css';

const Login = () => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.rootReducer.login.data);
  const error = useSelector((state) => state.rootReducer.login.error);
  const isLoading = useSelector((state) => state.rootReducer.login.loading);

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const [isValid, setIsValid] = useState(true);

  const handleEmailChange = (e) => {
    const newEmail = e.target.value;
    setEmail(newEmail);
    setIsValid(true);
  };

  const handleLogin = async () => {

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
    const isValidEmail = emailRegex.test(email);
    setIsValid(isValidEmail);
    if (email.length === 0) {
      alert("Please enter email!");
    } else if (password.length === 0) {
      alert("Please enter password");
    } else {
      if (isValidEmail) {
        const payload = {
          email: email,
          password: password,
          fcmToken: "nannyline",
        };
        dispatch(loginUser(payload));
      }
    }
  };

  const navigate = useNavigate();

const navigateToAnotherScreen = () => {
  if (user.data.type == 1) {
    navigate("/profilenanny");
  } else {
    navigate("/");
  }
  window.location.reload();
};


  useEffect(() => {
    if (user != null && user.status === 1) {
      if (localStorage.getItem("Token").length != null)
        navigateToAnotherScreen();
    } else if (user != null) {
      alert(user.message);
    }
  }, [user]);

  useEffect(() => {
    if (error) {
      alert(error)
      if (error === 'Please verify your account first.') {
        navigate('/otp', {
          state: {
            email: email,
            source: 'login'
          }
        });
        dispatch(clearData())
      }
    }
  }, [error, navigate]);


  const [visible, setVisible] = useState(false)

  const toggleVisible = () => {
    const scrolled = document.documentElement.scrollTop;
    if (scrolled > 300) {
      setVisible(true)
    }
    else if (scrolled <= 300) {
      setVisible(false)
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  window.addEventListener('scroll', toggleVisible);

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="container py-5">
          <a href="#" className="custom-logo d-block login-logo mx-auto">
            <img className="mw-100" src={logo} alt="logo" />
          </a>
          <div className="row">
            <div className="col-lg-6 offset-lg-3 offset-sm-1 col-sm-10">
              <div className="login-container">
                <form className="login-form" appearance="outline">
                  <h3>Welcome</h3>
                  <p>Please login to your account</p>
                  <div className="input-group">
                    <input
                      type="email"
                      value={email}
                      onChange={(e) => { handleEmailChange(e); setEmail(e.target.value) }}
                      placeholder="Email"
                    />

                    {email.length != 0 && !isValid ? (
                      <p style={{ color: "red", fontSize: "15px" }} className="mb-0 mt-1">
                        Invalid email address
                      </p>
                    ) : (
                      ""
                    )}

                  </div>
                  <div className="input-group mb-0">
                    <input
                      type={showPassword ? "text" : "password"}
                      id="password"
                      placeholder="Password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          handleLogin();
                        }
                      }}
                    />
                    <span
                      className="position-absolute end-0 top-50 translate-middle-y me-3"
                      style={{ cursor: "pointer" }}
                      onClick={() => setShowPassword(!showPassword)}
                    >
                      {showPassword ? (
                        <i className="fa fa-eye-slash" style={{ color: "#89d6ce" }}></i>
                      ) : (
                        <i className="fa fa-eye" style={{ color: "#89d6ce" }}></i>
                      )}
                    </span>

                  </div>
                  <p>
                    {" "}
                    <Link
                      className="d-flex justify-content-end mt-2 bottom-text"
                      style={{fontSize: "14px", opacity: 0.8, color: "#777"}}
                      to="/forgot-password"
                    >
                      Forgot Password?
                    </Link>
                  </p>
                  <Button type="button" onClick={() => handleLogin()}>
                    {isLoading ? (
                      <ClipLoader color="#fff" size={16} />
                    ) : (
                      "Login"
                    )}
                  </Button>

                  {/*{error && <p style={{ color: 'red' }}>{error}</p>}*/}
                  <div className="bottom-text">
                    <div className="mt-3 bottom_link" >
                      {/* Im a new here, */}
                      Don't have an account?
                      <div className='flex_link'>
                        <p className='link_color' onClick={() => { scrollToTop(); navigate('/signupnanny') }} > {" "}Sign up</p>
                      </div>
                    </div>
                  </div>
                  {/* <div>
                    <GoogleLogin
                      onSuccess={handleSuccess}
                      onError={handleError}
                      useOneTap
                      flow="auth-code"
                    />
                  </div> */}

                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
